import { DateTime } from 'luxon';

import { DateFormatPatterns } from '@clearverify/constants';
import { numberWithCommas } from '@clearverify/utils';

/**
 * The upload timestamp comes from MDM in UTC and the dashboard reports every date in UTC, so it's
 * rendered as-is instead of in the viewer's zone.
 */
export const formatLastUploadDate = (uploadedAt: string) =>
  DateTime.fromISO(uploadedAt, { zone: 'utc' }).toFormat(DateFormatPatterns.shortMonthDayYear);

/** A load can carry no role changes at all — then only the date is worth showing. */
export const formatLastUploadRecords = (rolesCount: number) =>
  rolesCount ? `${numberWithCommas(rolesCount)} records updated` : '';
